import React from "react";

const stats = [
  { k: "2025", v: "Alapítva október", d: "Friss lendülettel, modern eszközökkel és AI támogatással." },
  { k: "100%", v: "Munkavégzési garancia", d: "Írásban, minden megrendelésre." },
  { k: "300km", v: "Kiszállási körzet", d: "Tápióbicskéről, az egész országban." },
];

export default function Stats() {
  return (
    <section id="rolunk" data-testid="stats-section" className="border-b border-[#262626] bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
          [ 03 / Számokban ]
        </div>
        <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none mb-12">
          Nem dumálunk.<br />
          <span className="text-[#FFD700]">Csinálunk.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#262626]">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="border-r border-b border-[#262626] p-8 group hover:bg-black transition-colors"
            >
              <div className="font-heading text-5xl md:text-7xl text-[#FFD700] leading-none group-hover:scale-105 transition-transform origin-left">
                {s.k}
              </div>
              <div className="mt-4 font-heading uppercase text-lg">{s.v}</div>
              <div className="mt-2 font-mono text-xs text-[#A3A3A3]">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
